/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Menu,
} from 'antd';
import {
  UserOutlined,
  FileTextOutlined,
  CheckSquareOutlined,
  CalendarOutlined,
  QuestionCircleOutlined,
  EditOutlined,
  SolutionOutlined,
  CheckCircleOutlined,
  HighlightOutlined,
} from '@ant-design/icons';

// Tus componentes
import Vacantes from '../../../components/Reclutamiento/Vacantes/Vacantes';
import Pruebas from '../../../components/Reclutamiento/Pruebas/Pruebas';
import Citas from '../../../components/Reclutamiento/Citas';
import Entrevistas from '../../../components/Reclutamiento/Entrevistas/Entrevistas';
import AplicacionDePruebas from '../../../components/Reclutamiento/AplicacionDePruebas/AplicacionDePruebas';
import Evaluaciones from '../../../components/Reclutamiento/Evaluaciones/Evaluaciones';
import Informe from '../../../components/Reclutamiento/Informe/Informes';
import Contratacion from '../../../components/Reclutamiento/Contratacion/Contratacion';

const { Content } = Layout;
const { Title, Text } = Typography;

export const reclutamientoRHPermission = {
  permissionModel: 'solicituddecontratacion',
};

const ReclutamientoRH = ({ permission }) => {
  const [selectedView, setSelectedView] = useState('dashboard'); // default

  const renderComponent = () => {
    switch (selectedView) {
      case 'vacantes': return <Vacantes permission={permission} />;
      case 'pruebas': return <Pruebas />;
      case 'citas': return <Citas />;
      case 'entrevista': return <Entrevistas />;
      case 'aplicar_pruebas': return <AplicacionDePruebas />;
      case 'evaluaciones': return <Evaluaciones />;
      case 'informe': return <Informe />;
      case 'contrataciones': return <Contratacion />;
      default: return <MainDashboard setSelectedView={setSelectedView} />;
    }
  };

  return (
    <div>
      <Menu
        mode="horizontal"
        selectedKeys={[selectedView]}
        onClick={(e) => setSelectedView(e.key)}
        style={{ marginBottom: 16 }}
      >
        {/* <Menu.Item key="dashboard" icon={<UserOutlined />}> */}
        {/* Dashboard
        </Menu.Item> */}
        <Menu.Item key="vacantes" icon={<FileTextOutlined />}>
          Vacantes
        </Menu.Item>
        {/* <Menu.Item key="pruebas" icon={<CheckSquareOutlined />}>
         Asignacion Pruebas
        </Menu.Item> */}
        {/* <Menu.Item key="citas" icon={<CalendarOutlined />}>
          Citas
        </Menu.Item> */}
        {/* <Menu.Item key="entrevista" icon={<QuestionCircleOutlined />}>
           Entrevista
        </Menu.Item>
        <Menu.Item key="aplicar_pruebas" icon={<EditOutlined />}>
           Aplicación de Pruebas
        </Menu.Item>
        <Menu.Item key="evaluaciones" icon={<HighlightOutlined />}>
           Evaluaciones
        </Menu.Item> */}
        {/* <Menu.Item key="informe" icon={<SolutionOutlined />}>
          Informe
        </Menu.Item>
        <Menu.Item key="contrataciones" icon={<CheckCircleOutlined />}>
          Contrataciones
        </Menu.Item> */}
      </Menu>

      {renderComponent()}
    </div>
  );
};

function MainDashboard({ setSelectedView }) {
  const iconMap = {
    vacantes: <FileTextOutlined style={{ fontSize: 18 }} />,
    pruebas: <CheckSquareOutlined style={{ fontSize: 18 }} />,
    citas: <CalendarOutlined style={{ fontSize: 18 }} />,
    user: <UserOutlined style={{ fontSize: 18 }} />,
  };
  const dashboardCards = [
    {
      key: 'vacantes', title: 'Estatus de Vacantes', count: 8,
    },
    {
      key: 'pruebas', title: 'Asignar Pruebas', count: 5,
    },
    {
      key: 'citas', title: 'Citas Programadas', count: 7,
    },
    {
      key: 'user', title: 'Entrevistas Pendientes', count: 9,
    },
  ];
  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        {dashboardCards.map(({
          key, title, count,
        }) => (
          <Col key={key} xs={24} sm={12} lg={6}>
            <Card hoverable onClick={() => setSelectedView(key)}>
              <Row gutter={8} align="middle">
                <Col>
                  <Text strong>{title}</Text>
                </Col>
                <Col>{iconMap[key]}</Col>
              </Row>
              <Title level={3}>{count}</Title>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default ReclutamientoRH;
